/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A model representing an email template.
 */
export interface EmailTemplateModel { 
    /**
     * Template ID.
     */
    id: number;
    /**
     * ID of case where the template belongs.
     */
    caseId: number;
    /**
     * Name of the template.
     */
    name: string;
    /**
     * Language in which the template is written.
     */
    language: string;
    /**
     * The group of template.
     */
    group: number;
    /**
     * The subject line in template.
     */
    subject: string;
    /**
     * The body of the template.
     */
    body: string;
    /**
     * The current status of the template.
     */
    status: number;
}

